// @flow
import React, { Component, type ElementRef } from "react";
import { Card, Page, TextContainer } from "@shopify/polaris";
import { Modal, TitleBar } from "@shopify/app-bridge-react";

import { shopActions } from "store/shopStore";
import { storeConnect } from "appStore";
import makeRequestProps from "store/makeRequestProps";

import { hasDiscountScopes } from "lib/scopesHelpers";

import { NavigationContext } from "contexts/Navigation";
import type { ShopRequest } from "appStore";
import type { OffersSettings } from "types/flow-types/settings";

import SettingsFormWrapped from "./SettingsFormWrapped";

type Props = {
  companionAppsInstalled?: boolean,
  putSettings: (OffersSettings, () => void) => void,
  shopRequest: ShopRequest
};

type State = {
  cancelAlertOpen: boolean
};

type FormRef = { current: ?ElementRef<"form"> } | null;

export class SettingsRoute extends Component<Props, State> {
  static contextType = NavigationContext;

  formRef: ?FormRef;
  constructor(props: Props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      cancelAlertOpen: false
    };
  }

  navigateToRoot = () => {
    this.context.goTo("/");
  };

  handleBarSaveClick = () => {
    // $FlowDisableNextLine
    this.formRef.current.props.form.submitForm();
  };

  handleSubmit = (values: OffersSettings) => {
    this.props.putSettings(values, this.navigateToRoot);
  };

  handleCancel = () => {
    // $FlowDisableNextLine
    const { form } = this.formRef.current.props;

    if (form.dirty) {
      return this.setState({ cancelAlertOpen: true });
    }

    this.navigateToRoot();
  };

  render() {
    const {
      shopRequest: {
        shop: {
          app_settings: settings,
          customizations,
          productBoardToken,
          shopify_scopes: shopifyScopes
        }
      }
    } = this.props;

    const shopHasDiscountScopes = hasDiscountScopes(shopifyScopes);

    return (
      <Page>
        <TitleBar title="Settings">
          <button variant="primary" onClick={this.handleBarSaveClick}>
            Save
          </button>
          <button onClick={this.handleCancel}>Cancel</button>
        </TitleBar>
        <SettingsFormWrapped
          settings={settings}
          companionAppsInstalled={this.props.companionAppsInstalled}
          customizations={customizations}
          formRef={this.formRef}
          hasDiscountScopes={shopHasDiscountScopes}
          onCancel={this.handleCancel}
          onSubmit={this.handleSubmit}
          productBoardToken={productBoardToken}
        />
        <Modal open={this.state.cancelAlertOpen}>
          <TitleBar title="You have unsaved changes">
            <button
              variant="primary"
              tone="critical"
              onClick={() => {
                this.setState({ cancelAlertOpen: false });
                this.context.goTo("/");
              }}
            >
              Leave page
            </button>
            <button onClick={() => this.setState({ cancelAlertOpen: false })}>
              Cancel
            </button>
          </TitleBar>
          <Card>
            <Card.Section>
              <TextContainer>
                <p>
                  If you leave this page, all your unsaved changes will be lost.
                  Are you sure you want to discard these changes and leave this
                  page?
                </p>
              </TextContainer>
            </Card.Section>
          </Card>
        </Modal>
      </Page>
    );
  }
}

const mapStateToProps = state => {
  return {
    companionAppsInstalled: state.companionAppsInstalled,
    shopRequest: makeRequestProps(state, "shop")
  };
};

export default storeConnect(SettingsRoute, mapStateToProps, shopActions);
